import $ from 'jquery';
import {isEmpty} from './Helpers';
import ToggleButton from './parts/ToggleButton';
import Toolbar from './parts/Toolbar';

class State{

    constructor(){
        this._data = {};
        this.info={};
        this.darkContrastState= false;
        this.highlightingLinks= false;
        this.maxFontSize= 28;
        this.minFontSize= 12;
        this.fontTypes = ['p', 'a', 'input', 'select', 'button', 'strong', 'small', 'h1', 'h2', 'h3', 'h4', 'h5', 'th', 'td', 'li', 'dl', 'dd', 'section', 'article', 'span', 'div', 'body']
        this.setContrast= false;
        this.setCursor= false;
        this.highlightLinks= false;
        this.fixFonts= false;
        this.setZoom= false;
        this.keyboardNav= false;

    }

    get info() {
        return this._data.info;
    }
    set info(info) {
        this._data.info = info;
    }

    get fontTypes(){ return this._data.fontTypes}
    set fontTypes(x){ this._data.fontTypes = x }

    get maxFontSize(){ return this._data.maxFontSize}
    set maxFontSize(x){ this._data.maxFontSize = x }

    get minFontSize(){ return this._data.minFontSize}
    set minFontSize(x){ this._data.minFontSize = x }

    get setContrast(){ return this._data.setContrast}
    set setContrast(x){ this._data.setContrast = x }

    get setCursor(){ return this._data.setCursor}
    set setCursor(x){ this._data.setCursor = x }

    get highlightLinks(){ return this._data.highlightLinks}
    set highlightLinks(x){ this._data.highlightLinks = x }

    get fixFonts(){ return this._data.fixFonts}
    set fixFonts(x){ this._data.fixFonts = x }

    get setZoom(){ return this._data.setZoom}
    set setZoom(x){ this._data.setZoom = x }

    get keyboardNav(){ return this._data.keyboardNav}
    set keyboardNav(x){ this._data.keyboardNav= x }

}

export const state = new State()